import React, { useEffect, useState } from 'react';
import SelectAsyncComponent from '../../../componentes/select/select-async.component';
import {
	Row,
	Col,
	FormGroup,
	Label,
	Input,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
} from 'reactstrap';
import SelectCreatableComponent from '@componentes/select/select-creatable.component';
import IntlMessage from '../../../helpers/intlMessage';
import { useIntl } from 'react-intl';
import { httpRequest } from '@util/api-common.util';
import WebapiCommon from '@util/webapi.common';

const CitologiaEditModalPage = (props) => {
	const intl = useIntl();
	const [anotacoes, setAnotacoes] = useState('');

	useEffect(() => {
		props.patologistas.filter((patologista) => {
			if (props.laminaSelecionada.medicoId === patologista.value) {
				props.setState({ patologista: patologista });
			}
		});

		WebapiCommon.getConfiguracoesGerais().then((res) => {
			if (res.gravarSugestaoComplementoCitologia){
				props.complementos.filter((complemento) => {
					if (props.laminaSelecionada.complemento === complemento.label) {
						props.setState({ complememtoLamina: complemento });
					}
				});
			}
			else {
				var item = props.complementos.find(obj => obj.label === props.laminaSelecionada.complemento);
				if(item) {
					props.setState({ complememtoLamina: item });
				}
				else{
					if (props.laminaSelecionada && props.laminaSelecionada.complemento){
						props.handleCreateSelectCreatable(props.laminaSelecionada.complemento);
					}
				}
			}

			console.log(props.laminaSelecionada);

			props.laminaSelecionada && props.laminaSelecionada.observacao
				? setAnotacoes(props.laminaSelecionada.observacao)
				: setAnotacoes('');
			})
	}, [props.laminaSelecionada]);

	const limparCampos = () => {
		props.setState({
			complememtoLamina: null,
			patologista: {},
			laminaSelecionada: {},
		});

		setAnotacoes('');
	};

	const editarLamina = () => {
		const body = {
			complemento: props.complememtoLamina.label,
			medicoId: props.patologista.value,
			observacao: anotacoes,
			laudo: props.laminaSelecionada.laudo,
			idExterno: props.laminaSelecionada.idExterno,
			idLamina: props.laminaSelecionada.idLamina,
		};

		httpRequest('lamina/alterar-dados-lamina', 'PATCH', body).then((res) => {
			props.commonActions.showAlerta(
				'sucesso',
				'Lâmina editada com sucesso!',
				1500
			);
			props.toggle();
			limparCampos();
			props.buscar();
		});
	};

	function translate(key) {
		return intl.formatMessage({ id: key });
	}
	return (
		<Modal isOpen={props.open} toggle={props.toggle} size="lg">
			<div className="citologia-modal-page">
				<ModalHeader toggle={props.toggle}>
					<IntlMessage id="dashboards.examDetail.table.editComplement" />
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetail.table.complement" />
								</Label>
								<SelectCreatableComponent
									onChange={(ev) => props.setState({ complememtoLamina: ev })}
									onCreateOption={props.handleCreateSelectCreatable}
									options={props.complementos}
									placeholder={translate(
										'dashboards.examDetail.selectBladeAddOn'
									)}
									label={
										<IntlMessage id="dashboards.examDetail.registerNewAddOn" />
									}
									value={props.complememtoLamina}
								/>

							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetail.annotations" />
								</Label>
								<Input
									type="textarea"
									maxLength={300}
									onChange={(ev) => setAnotacoes(ev.target.value)}
									value={anotacoes}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.cytology.pathologist" />
								</Label>
								<SelectAsyncComponent
									options={props.patologistas}
									value={props.patologista}
									placeholder={translate(
										'dashboards.examDetail.selectPathologist'
									)}
									onChange={(ev) => {
										props.setState({ patologista: ev });
									}}
								/>
							</FormGroup>
						</Col>
					</Row>
				</ModalBody>
				<ModalFooter className="paddingTop-none">
					{!props.laudoNaoExiste && (
						<Button color="danger" onClick={() => limparCampos()}>
							<IntlMessage id="dashboards.examDetail.clearFields" />
						</Button>
					)}
					<Button
						color="secondary"
						onClick={() => {
							props.toggle();
							limparCampos();
						}}
					>
						<IntlMessage id="dashboards.examDetails.cancel" />
					</Button>
					<Button color="primary" onClick={editarLamina}>
						<IntlMessage id="general.materialArchiving.save" />
					</Button>
				</ModalFooter>
			</div>
		</Modal>
	);
};
export default CitologiaEditModalPage;



// WEBPACK FOOTER //
// ./src/pages/citologia/content/citologia.edit.modal.page.js